import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const DEFAULT_BUTTON_CHILDREN = <MoreVertIcon />;

const OptionsDropdown = ({
  children,
  buttonChildren = DEFAULT_BUTTON_CHILDREN,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-controls={open ? 'menu-appbar' : undefined}
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        size="large"
      >
        {buttonChildren}
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        {React.Children.map(children, (child) => {
          if (!child) {
            return null;
          }
          const onClick = () => {
            handleClose();
            child.props.onClick();
          };
          return React.cloneElement(child, { onClick });
        })}
      </Menu>
    </>
  );
};

OptionsDropdown.propTypes = {
  buttonChildren: PropTypes.node,
  children: PropTypes.node,
};

export default OptionsDropdown;
